import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('DoubleSelectController', DoubleSelectController);

    function DoubleSelectController() {
        var vm = this;

        init();

        function init() {
            vm.selectItem = selectItem;
            vm.removeItem = removeItem;
            vm.moveDown = moveDown;
            vm.moveUp = moveUp;

            removeSelectedItemsFromOptions();
        }

        function removeSelectedItemsFromOptions() {
            vm.options = vm.options.filter(function (item) {
                return !vm.selected.includes(item);
            });
        }

        function selectItem(item, optionsArrIdx) {
            vm.selected.push(item);
            vm.options.splice(optionsArrIdx, 1);
        }

        function removeItem(item, selectedArrIdx) {
            vm.options.push(item);
            vm.selected.splice(selectedArrIdx, 1);
        }

        function moveDown(idx) {
            var tmpItem = vm.selected[idx + 1];
            vm.selected.splice(idx + 1, 1);
            vm.selected.splice(idx, 0, tmpItem);
        }

        function moveUp(idx) {
            var tmpItem = vm.selected[idx - 1];
            vm.selected.splice(idx - 1, 1);
            vm.selected.splice(idx, 0, tmpItem);
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/forms/double-select/double-select.controller.ts